<template>
  <component
    :is="pageLayoutComponent"
    title="Vyloučené zacílení"
    :next="nextRoute"
    :prev="prevRoute"
  >
    <ReachDialBox :store-namespace="storeNamespace" class="mb-8" />
    <ui-section
      title="Vylučte lidi pro ještě lepší cílení"
      subtitle="Pokud nevíte, koho vyloučit, tuto sekci přeskočte"
    >
      <excluded-interests-group
        :items="excludedInterests"
        @itemsAppend="excludedInterestsAppend"
        @itemsRemove="excludedInterestsRemove"
      />
    </ui-section>
  </component>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

// import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import ReachDialBox from "@/components/ui/targeting/ReachDialBox.vue"
import ExcludedInterestsGroup from "@/components/ui/targeting/ExcludedInterestsGroup.vue"

export default {
  name: "TargetingExcludedInterests",
  components: {
    // PageLayout,
    ReachDialBox,
    ExcludedInterestsGroup,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...sync("app", ["videoTutorial"]),

    pageLayoutComponent() {
      return () =>
        import(`@/components/page/${this.storeNamespace}/edit/PageLayout.vue`)
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@audience.targeting`, [
        "excludedInterests",
      ]),
    })

    Object.assign(this.$options.methods, {
      ...call(`${storeNamespace}`, [
        "excludedInterestsAppend",
        "excludedInterestsRemove",
      ]),
    })
  },
  mounted() {
    this.videoTutorial = "https://player.vimeo.com/video/693588062?h=9fc8cc1cfd"
  },
}
</script>

<style scoped>
.addBtn {
  width: 100%;
  height: 100%;
  color: #595285;
  font-size: 12px;
  font-weight: bold;
  border: 1px dashed #d7d7e2;
  border-radius: 6px;
  transition: all 0.3s;
}

.addBtn__content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 32px;
}

.addBtn:hover {
  background: rgba(215, 215, 226, 0.25);
}
</style>
